<template>
  <v-app><router-view></router-view>
  </v-app>
</template>

<script lang="ts">
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({})
export default class App extends Vue {
  public async mounted() {
    window.addEventListener('resize', this.resetHeight); // Set the height whenever the screen is resized
    this.resetHeight();
  }

  public resetHeight() {
    // The inner height is the space between the navigation- and bottom bar (from the browser)
    document.body.style.height = window.innerHeight + 'px';
  }

}
</script>
